import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useMemo } from "react";

import useMonthlyFilter from "components/pages/dashboard/doctor_analytic/filter/monthly_filter/useMonthlyFilter";
import { getCurrentYearAndMonth } from "utils/date";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";

const MonthlyFilter = () => {
  const { months } = useMonthlyFilter();
  const { year, month } = useSelector((state) => state.nonCompliantPatient);

  const filteredMonths = useMemo(() => {
    const { currentYear, currentMonth } = getCurrentYearAndMonth();
    return currentYear !== Number(year)
      ? months
      : months.filter((month) => month.value <= currentMonth);
  }, [year, months]);

  const dispatch = useDispatch();

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="month-select-label">Month</InputLabel>

        <Select
          labelId="month-select-label"
          id="month-select-helper"
          value={month}
          label="Month"
          onChange={(e) => {
            dispatch(
              setFilter({
                type: "month",
                value: e.target.value,
              })
            );
          }}
        >
          {filteredMonths &&
            filteredMonths.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </>
  );
};

export default MonthlyFilter;
